<template>
    <div class="verify-code">
        <Input class="input-code" v-model="state.code" @change="handleCodeChange" placeholder="请输入验证码" />
        <div class="btn-right">
            <span v-if="state.firstSendCode" @click="handleSendCode" class="btn-code"
                style="color: rgb(11, 126, 230);">获取验证码</span>
            <span class="time" v-else>
                <span class="num" v-if="state.countNum">{{ state.countNum }}s 后可再次发送</span>
                <span v-else @click="handleSendCode" class="btn-code">重新发送</span>
            </span>
        </div>
    </div>
</template>
<style lang="less">
.verify-code {
    margin-top: 25px;
    position: relative;
    .input-code {
        width: 100%;
    }
    .btn-right {
        position: absolute;
        top: 0px;
        right: 12px;
        line-height: 32px;
    }
    .btn-code {
        color: rgb(11, 126, 230);
        float: right;
        cursor: pointer;
    }
    .time {
        margin-left: 6px;
        color: rgb(153, 153, 153);
        .num {
            font-size: 12px;
        }
    }
}
</style>
<script setup>
import { reactive, ref, onBeforeUnmount, defineExpose, defineProps, defineEmits } from 'vue';
import platform from '../../data/platform'
import { Message, Input } from 'view-ui-plus'
import lodash from 'lodash'

console.log('_', lodash, window._)

const props = defineProps({
    type: {
        type: String,
        default: 'mobile'
    },
    userInfo: {
        type: Object,
        default: () => {}
    },
    modelValue: String
})

const emit = defineEmits(['update:modelValue'])
const state = reactive({
    firstSendCode: true,
    countNum: null,
    code: ''
})
const si = ref(null)
onBeforeUnmount(() => {
    si.value && clearInterval(si.value)
})
const checkMobile = async (mobile) => {
    let tips = ''
    if (!mobile) {
        tips = '请输入手机号码'
    } else {
        const res = await platform.checkMobileApi({
            id: props.userInfo.id,
            mobile,
            mobileAreaCode: props.userInfo.mobileAreaCode
        })
        if (res && res.code != '0')
        tips = res.msg || '请输入正确的手机号码'
    }
    return tips
}
const checkEmail = (email) => {
    const emailReg = /^([a-zA-Z0-9_-]+)@([a-zA-Z0-9_-]+)(\.[a-zA-Z0-9_-]+)$/
    let tips = ''
    if (!email) {
        tips = '请输入邮箱'
    } else if (!emailReg.test(email)) {
        tips = '请输入正确的邮箱'
    }
    return tips
}

const handleSendCode = async () => {
    getVerifyCode()
}

const countDown = () => { // 倒计时
    state.countNum = 60
    si.value = setInterval(() => {
        state.countNum--
        if (state.countNum <= 0) {
            clearInterval(si.value)
            si.value = null
        }
    }, 1000)
}
const getVerifyCode = window._.debounce(async () => {
    try {
        const res = await platform.getMobileCodeV2()
        const { data: { code, msg } } = res
        if (code === '0') {
            state.firstSendCode = false
            countDown()
            Message.success('验证码已发送')
        } else {
            Message.warning(msg || '验证码发送失败')
        }
    } catch (e) {
        console.error(e)
    }
}, 300)
const handleCodeChange = () => {
    emit('update:modelValue', state.code)
}

const clearCode = () => {
    state.code = ''
    emit('update:modelValue', '')
}
defineExpose({
    checkEmail,
    checkMobile,
    getVerifyCode,
    clearCode
})
</script>